import { Link } from "react-router-dom";
import StarRating from "@/components/base/StarRating";
import { testimonials } from "@/mocks/site";

export default function TestimonialSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-bold text-secondary-900">
              <i className="ri-chat-smile-3-line" />
              用户口碑
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              4.9 分口碑，来自 128 万用户的真实选择
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              从深夜加班的一碗热面，到团队下午茶的整单配送，美味的快递已经陪伴无数城市生活者，把每一次期待准时送达。
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition hover:bg-primary-50"
            >
              了解我们的故事
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-2">
            {testimonials.map((t) => (
              <article
                key={t.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-300" />
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.content}</p>
                <div className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <img
                    src={t.avatar}
                    alt={`${t.name} 的用户头像`}
                    title={`${t.name} - 美味的快递用户`}
                    className="h-11 w-11 rounded-full object-cover"
                  />
                  <div className="flex-1">
                    <p className="font-heading text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                  <StarRating rating={t.rating} size="text-xs" showValue={false} />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}